import React from "react";

/**
 * One door-photo thumbnail in the event-detail popup's photo panel, with the
 * photo's note as a label band along its bottom edge.
 *
 * The band holds the note twice: `-one` is the single truncated line shown at
 * rest, `-full` is the wrapped text the band grows to on hover (wide windows
 * only, see eventDetailPopup.css). `-one` is aria-hidden so the note is
 * announced once. No note → no band, and the cell looks like a plain photo.
 *
 * The <img> stays a plain load with no crossOrigin (registry §23.6;
 * noCrossOriginImg.test.js).
 */
const EventPhotoCell = ({ thumb, full, note, index, onOpen }) => {
  const label = typeof note === "string" ? note.trim() : "";

  return (
    <div
      className="event-detail-photo-cell"
      onClick={() => onOpen({ src: full, note: label })}
    >
      <img
        className="event-detail-photo"
        src={thumb}
        alt={`Door ${index + 1}`}
        loading="lazy"
      />
      {label && (
        <div className="event-detail-photo-label">
          <div className="event-detail-photo-label-inner">
            <span className="event-detail-photo-label-one" aria-hidden="true">
              {label}
            </span>
            <span className="event-detail-photo-label-full">{label}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default EventPhotoCell;
